import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpregistrywrite0postPostRegistrySyncResponseSchema = jsonObject
export type tcpregistrywrite0postPostRegistrySyncResponse = z.infer<typeof tcpregistrywrite0postPostRegistrySyncResponseSchema>
export const tcpregistrywrite0postPostRegistryIngestResponseSchema = jsonObject
export type tcpregistrywrite0postPostRegistryIngestResponse = z.infer<typeof tcpregistrywrite0postPostRegistryIngestResponseSchema>
